import { Provider } from '@angular/core';
import { APP_CONFIG } from './app-config.token';
import { runtimeConfig } from './runtime-config';

export const provideAppConfig = (): Provider[] => [
  {
    provide: APP_CONFIG,
    useFactory: () => {
      return {
        ...runtimeConfig,
        panelDesarrolloLocalVisible:
          runtimeConfig.environment === 'dev' &&
          runtimeConfig.panelDesarrolloLocalVisible &&
          runtimeConfig.auth.modo !== 'entra',
      };
    },
  },
];
